import { Record } from 'immutable';

export default class EntityViewRecord extends Record({
  id: null,
  createdAt: null,
  entity: null,
}) {
}
